import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=473059c2&scoped=true"
import script from "./WechatLogin.vue?vue&type=script&lang=js"
export * from "./WechatLogin.vue?vue&type=script&lang=js"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=473059c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473059c2",
  null
  
)

export default component.exports